exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-image[data-v-02bf87ae] {\n  min-width: 5rem;\n  max-width: 5rem;\n  min-height: 5rem;\n  max-height: 5rem;\n}\n.source-details[data-v-02bf87ae] {\n  -moz-column-count: 2;\n       column-count: 2;\n}", ""]);

// exports
